import { BaseChangeControlStatus } from '../types/baseQualityItem';

export function isStaged(changeControlStatus: BaseChangeControlStatus): boolean {
  return changeControlStatus && changeControlStatus !== 'unstaged';
}
